module.exports = __webpack_public_path__ + "img/gwyx-hlxfc.bd45ec54.png";